import { useContext, useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { ACTIVE_TOURNAMENT } from '@/constants';
import { FirebaseContext } from '@/session/FirebaseContext';
import type { ProgressionAward } from '@/models/scoring';

/** Live WC-26 progression awards (e.g. out-of-groups +3). Requires auth — see firestore.rules. */
export function useProgressionAwards(): ProgressionAward[] {
  const ctx = useContext(FirebaseContext);
  const [progressionAwards, setProgressionAwards] = useState<ProgressionAward[]>([]);

  useEffect(() => {
    const q = query(
      collection(ctx.db, 'competitions', ACTIVE_TOURNAMENT, 'progressionAwards'),
      orderBy('matchday'),
    );
    return onSnapshot(
      q,
      (snap) => {
        setProgressionAwards(snap.docs.map((doc) => doc.data() as ProgressionAward));
      },
      (error) => {
        console.error(error);
        setProgressionAwards([]);
      },
    );
  }, [ctx.db]);

  return progressionAwards;
}
